import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import styled from 'styled-components';
import { FaDiscord, FaInfoCircle } from 'react-icons/fa';
import { toast } from 'react-toastify';

const LoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #0a0e17;
  color: #ffffff;
`;

const LoginCard = styled.div`
  background-color: #121921;
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.5);
  padding: 30px;
  width: 90%;
  max-width: 400px;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 24px;
  margin-bottom: 20px;
  color: #00ff4c;
`;

const DiscordButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background-color: #5865F2;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 12px 20px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  width: 100%;
  transition: background-color 0.3s;
  
  &:hover {
    background-color: #4752c4;
  }
  
  &:disabled {
    background-color: #3f3f6e;
    cursor: not-allowed;
  }
`;

const InfoText = styled.p`
  margin-top: 20px;
  font-size: 14px;
  color: #aaa;
`;

const ErrorBox = styled.div`
  background-color: rgba(244, 67, 54, 0.1);
  border-left: 3px solid #f44336;
  padding: 10px 15px;
  margin: 15px 0;
  text-align: left;
  font-size: 14px;
  color: #ff9494;
  display: flex;
  align-items: flex-start;
  gap: 10px;
`;

const Login = () => {
  const { currentUser, isAdmin, getAuthUrl } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  
  // URL'den hata mesajlarını al
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const errorParam = params.get('error');
    
    if (errorParam) {
      if (errorParam === 'access_denied') {
        setError('Discord yetkilendirmeyi reddettiniz. Giriş yapabilmek için Discord hesabınıza erişim izni vermeniz gerekmektedir.');
      } else {
        setError(`Discord ile giriş sırasında bir hata oluştu: ${errorParam}`);
      }
    }
  }, [location]);
  
  // Kullanıcı zaten giriş yapmışsa ve admin ise dashboard'a yönlendir
  useEffect(() => {
    if (currentUser) {
      if (isAdmin) {
        navigate('/admin');
      } else {
        navigate('/');
        toast.error('Admin paneline erişim izniniz yok. Yönetici rolüne sahip olmanız gerekmektedir.');
      }
    }
  }, [currentUser, isAdmin, navigate]);
  
  const handleDiscordLogin = () => {
    try {
      setIsLoading(true);
      setError('');
      const authUrl = getAuthUrl();
      window.location.href = authUrl;
    } catch (error) {
      console.error('Login error:', error);
      setError('Giriş URL\'i oluşturulurken bir hata oluştu: ' + error.message);
      setIsLoading(false);
    }
  };
  
  return (
    <LoginContainer>
      <LoginCard>
        <Title>Kinfhertix Admin Girişi</Title>
        
        {error && (
          <ErrorBox>
            <FaInfoCircle style={{ marginTop: '2px' }} />
            <div>{error}</div>
          </ErrorBox>
        )}
        
        <DiscordButton onClick={handleDiscordLogin} disabled={isLoading}>
          <FaDiscord size={24} />
          {isLoading ? 'Yönlendiriliyor...' : 'Discord ile Giriş Yap'}
        </DiscordButton>
        
        <InfoText>
          Yalnızca yönetici ve kurucu rolüne sahip Discord kullanıcıları admin paneline erişebilir.
        </InfoText>
      </LoginCard>
    </LoginContainer>
  );
};

export default Login; 